import { render } from "./SocialsPage.vue?vue&type=template&id=69ca20d4"
import script from "./SocialsPage.vue?vue&type=script&lang=js"
export * from "./SocialsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__